var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5246 6.40016C12.4436 6.25559 12.2908 6.16601 12.1249 6.16601H8.95648L9.37342 1.16251C9.39087 0.953054 9.26354 0.758606 9.06459 0.690802C8.86654 0.622539 8.64611 0.69888 8.53195 0.875452L3.49035 8.66702C3.39903 8.80801 3.3921 8.98768 3.47245 9.13514C3.5528 9.28261 3.7072 9.37434 3.87504 9.37434H7.04664L6.62635 14.8392C6.61002 15.0504 6.7407 15.2454 6.94234 15.3105C6.98889 15.3255 7.03633 15.3327 7.08334 15.3327C7.23954 15.3327 7.38947 15.2524 7.47452 15.1134L12.5161 6.86345C12.6025 6.72202 12.6059 6.54474 12.5246 6.40016ZM7.68647 13.0083L7.99865 8.95121C8.00851 8.82388 7.96465 8.6983 7.87803 8.60451C7.7912 8.51098 7.66923 8.45767 7.54167 8.45767H4.71762L8.30794 2.90879L8.00158 6.58639C7.99106 6.71418 8.03426 6.84033 8.12109 6.93478C8.20791 7.02902 8.33009 7.08267 8.45833 7.08267H11.3077L7.68647 13.0083Z",
    fill: "#6C63FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderIcon);
export default __webpack_public_path__ + "static/media/thunderIcon.8dfbd60fc0d88370cf7363cd0c4b6cfa.svg";
export { ForwardRef as ReactComponent };